import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import AppContextProvider from '@crema/context/AppContextProvider';
import AppThemeProvider from '@crema/context/AppThemeProvider';
import AppStyleProvider from '@crema/context/AppStyleProvider';
import AppLocaleProvider from '@crema/context/AppLocaleProvider';
import InfoViewContextProvider from '@crema/context/InfoViewContextProvider';
import AuthRoutes from '@crema/components/AuthRoutes';
import AppLayout from './core/AppLayout';
import AppAuthProvider from '@libs/core/AuthProvider';
import RQProvider from '@libs/services/auth/src/react-query/RQProvider';
import { PlatformProvider, usePlatformContext } from './modules/auth/AuthPage/Platform/PlatformContext';
import PlatformAuth from './modules/auth/AuthPage/PlatformAuth';
import UserPropertyTracker from './modules/auth/components/UserPropertyTracker';
import { installMuiXMissingLicenseWatermarkHider } from './core/utils/hideMuiXMissingLicenseWatermark';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import './assets/styles/maps.css';

// Platform 정보와 함께 Auth를 제공하는 wrapper
const ArtCloudAuthWrapper = ({ children }: { children: React.ReactNode }) => {
  const { clearPlatformInfo } = usePlatformContext();

  return <AppAuthProvider onLogout={clearPlatformInfo}>{children}</AppAuthProvider>;
};

const App = () => {
  useEffect(() => {
    // MUI 워터마크 삭제 유틸리티 적용
    return installMuiXMissingLicenseWatermarkHider();
  }, []);

  return (
    <AppContextProvider>
      <AppThemeProvider>
        <AppStyleProvider>
          <AppLocaleProvider>
            <BrowserRouter>
              <PlatformProvider>
                <InfoViewContextProvider>
                  <RQProvider>
                    <ArtCloudAuthWrapper>
                      <UserPropertyTracker />
                      <AuthRoutes>
                        <CssBaseline />
                        <PlatformAuth />
                        <AppLayout />
                      </AuthRoutes>
                    </ArtCloudAuthWrapper>
                  </RQProvider>
                </InfoViewContextProvider>
              </PlatformProvider>
            </BrowserRouter>
          </AppLocaleProvider>
        </AppStyleProvider>
      </AppThemeProvider>
    </AppContextProvider>
  );
};

export default App;
